import React from 'react';
import { useSearchParams } from 'react-router-dom';

import Buscando from 'Component/Buscando';
import Cabecalho from 'Component/Cabecalho';
import LayoutDefault from 'Component/Layout';
import Paginacao from 'Component/Paginacao';
import { RelogioDePontoLista } from 'Component/RelogioDePonto';
import SemRegistros from 'Component/SemRegistros';
import { useAppSelector } from 'Store';
import { useRecuperarRelogiosDePontoQuery } from 'View/Service/Default/RelogiosDePonto';

const Historico = (): React.ReactElement => {
  const [searchParams] = useSearchParams();

  const usuario = useAppSelector((estado) => estado.autenticacao.usuario);

  const {
    data: { relogios_de_ponto, paginacao } = {},
    isFetching,
    isLoading,
  } = useRecuperarRelogiosDePontoQuery({
    contain: ['VinculosEmpregaticios.Empresas'],
    page: searchParams.get('pagina') || 1,
    options: { usuario_id: usuario?.id },
  });

  return (
    <LayoutDefault>
      <Cabecalho
        titulo="Meu histórico de relógio de ponto"
        descricao="Veja todo seu histório importado do relógio de ponto"
      />
      <Buscando exibir={isLoading} />
      <SemRegistros
        carregando={isLoading}
        registros={relogios_de_ponto?.length}
      />
      <React.Fragment>
        <div className="bg-white shadow-sm rounded">
          {relogios_de_ponto?.map((relogio) => (
            <RelogioDePontoLista
              key={`${relogio.id}-${relogio.modificado}`}
              dados={relogio}
              btnRemover={false}
              btnAssinar={true}
            />
          ))}
        </div>
      </React.Fragment>
      <Paginacao dados={paginacao} desabilitado={isFetching} />
    </LayoutDefault>
  );
};

export default Historico;
